import _ from 'lodash';

const isVisible = (viewModel, path, defaultValue) => {
    return _.get(viewModel, `${path}.aspects.ocular`, defaultValue);
};

export default {
    isVisible
};